module.exports = __webpack_public_path__ + "static/media/app-logo-mini.5f89e248.svg";